export default "__VITE_ASSET__DmE2LEmH__"